<div class="legales container-fluid custom-row">
  <div class="row">
    <div class="col-12">
      <p [innerHTML]="textoLegales | safeHtml"></p>
    </div>
  </div>
</div>
